// ----------------------------------------------------- All Imports ----------------------------------------------------

import gsap from "gsap";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import canadaflag from "../assets/navbar/canadaflag.svg";
import closeButton from "../assets/navbar/close-button.svg";
import fbImage from "../assets/navbar/fb.svg";
import indiaflag from "../assets/navbar/indiaflag.svg";
import instaImage from "../assets/navbar/insta.svg";
import linkedinImage from "../assets/navbar/linkedin.svg";
import menuLine from "../assets/navbar/menu-line.svg";
import microsoftpartner from "../assets/navbar/microsoftpartner.svg";
// import paramLogo from "../assets/navbar/PARAM-GROUP-OF-COMPANIES.svg";
import paramUSALogo from '../assets/navbar/paramUSALogo.png'
import unitedstatesflag from "../assets/navbar/unitedstatesflag.svg";
import xImage from "../assets/navbar/youtube.svg";

// ------------------------------------------------------ All Imports ----------------------------------------------------

const Header = () => {
  // ------------------------------------------- All Variables ----------------------------------------------------

  const location = useLocation();
  const headerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  //  -------------------------------------------  Function to determine if a link is active  -------------------------------------------

  const isActive = (path) => location.pathname === path;

  // ---------------------------------------------------------------- gsap UseEffects (Animation) ----------------------------------------------------

  useEffect(() => {
    gsap.fromTo(
      headerRef.current,
      { y: "-100%", opacity: 0 },
      {
        y: "0%",
        opacity: 1,
        duration: 2,
        ease: "power2.out",
      }
    );
  }, []);

  return (
    <header
      ref={headerRef}
      className="font-poppins h-full  1600:px-[64px] 1400:px-[50px] 1200:px-[35px] lg:px-[40px] sm:px-[16px] xs:px-[8px] py-4 relative z-50"
    >
      {/*  -------------------------------------------  Mini Navbar  -------------------------------------------  */}

      <div className="flex items-center md:justify-between max-md:justify-center">
        <Link to="/" className="850:w-0 md:w-[100px] xs:w-0">
          <img
            src={paramUSALogo}
            className="850:hidden md:flex xs:hidden"
            alt="Param Logo"
          />
        </Link>
        <div className="flex font-faustina justify-end max-tablet:justify-center items-center text-xs sm:text-sm md:text-base font-medium text-white 880:gap-[32px] 850:gap-[20px] w-full">
          <div className="flex max-428:flex-wrap 500:gap-4 428:gap-[10px] xs:gap-[8px]">
            {/* ----------------------------------------- USA flag --------------------------------------------------- */}
            <div className="flex-shrink-0 rounded-xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[3px]">
              <div className="rounded-lg bg-black flex items-center gap-2 500:px-3 xs:px-2 py-2 max-sm:gap-1">
                <img
                  src={unitedstatesflag}
                  className="xs:w-[12px] xs:h-[12px] 428:w-[16px] 428:h-[16px] md:w-[25px] md:h-[25px]"
                  alt="us flag"
                />
                <span className="xs:text-[12px] 428:text-[14px] md:text-[16px] font-normal whitespace-nowrap">
                  +1 732 404 0466
                </span>
              </div>
            </div>
            {/* ----------------------------------------- USA flag --------------------------------------------------- */}

            {/* ----------------------------------------- Indian flag --------------------------------------------------- */}
            <div className="flex-shrink-0 rounded-xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[3px]">
              <div className="rounded-lg bg-black flex items-center gap-2 max-sm:gap-1 500:px-3 xs:px-2 py-2">
                <img
                  src={indiaflag}
                  className="xs:w-[12px] xs:h-[12px] 428:w-[16px] 428:h-[16px] md:w-[25px] md:h-[25px]"
                  alt="india flag"
                />
                <span className="xs:text-[12px] 428:text-[14px] md:text-[16px] font-normal whitespace-nowrap">
                  +91 701 669 3717
                </span>
              </div>
            </div>
            {/* ----------------------------------------- Indian flag --------------------------------------------------- */}

            {/* ----------------------------------------- Canada flag --------------------------------------------------- */}
            <div className="flex-shrink-0 rounded-xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[3px]">
              <div className="rounded-lg bg-black flex items-center gap-2 500:px-3 xs:px-2 py-2 max-sm:gap-1">
                <img
                  src={canadaflag}
                  className="xs:w-[12px] xs:h-[12px] 428:w-[16px] 428:h-[16px] md:w-[25px] md:h-[25px]"
                  alt="canada flag"
                />
                <span className="xs:text-[12px] 428:text-[14px] md:text-[16px] font-normal whitespace-nowrap">
                  +1 647 833 7205
                </span>
              </div>
            </div>
            {/* ----------------------------------------- Canada flag --------------------------------------------------- */}
          </div>

          <div className="850:flex xs:hidden 880:gap-5 md:gap-3 font-poppins ">
            <span className="font=normal text-base max-803:text-sm">
              Connect With Us
            </span>
            <div className="880:gap-4 850:gap-3 flex">
              <a
                href="https://www.instagram.com/param_group?igsh=MWFyYTZpMTQ4emtw"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={instaImage}
                  className="w-3 sm:w-4 md:w-5 h-3 sm:h-4 md:h-5"
                  alt="Instagram icon"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/param1-group-of-companies/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={linkedinImage}
                  className="w-3 sm:w-4 md:w-5 h-3 sm:h-4 md:h-5"
                  alt="LinkedIn icon"
                />
              </a>
              <a
                href="https://www.facebook.com/people/Param-Group-of-Companies/100064194186278/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={fbImage}
                  className="w-3 sm:w-4 md:w-5 h-3 sm:h-4 md:h-5"
                  alt="Facebook icon"
                />
              </a>
              <a
                href="https://www.youtube.com/@paramgroupofcomanies"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={xImage}
                  className="w-3 sm:w-4 md:w-5 h-3 sm:h-4 md:h-5"
                  alt="Twitter icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/*  ------------------------------------------- Main Navbar  -------------------------------------------  */}

      <div className="flex flex-row md:flex-col 850:flex-row 850:justify-between md:gap-3 gap-10 items-center mt-4">
        {/*  ---------------------------------- Mobile sidebar button  -------------------------------------------  */}
        <button
          className="md:hidden text-white text-2xl sm:text-3xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? (
            <img src={closeButton} className="w-8 h-8" alt="close icon" />
          ) : (
            <img src={menuLine} className="w-8 h-8" alt="menu icon" />
          )}
        </button>

        {/* ------------------------------------------- Logo ----------------------------------------- */}

        <div className="flex items-center justify-center xs:mr-8 md:mr-0 mb-7 mt-6 max-850:mt-0 max-850:mb-0 1920:gap-[32px] 1500:gap-[16px] md:gap-[24px] xs:gap-[30px]">
          <Link to="/" className="">
            <img
              src={paramUSALogo}
              className="xs:w-[100px] 900:w-[120px] 1500:w-52 1200:w-[180px] lg:w-[150px] h-auto 850:items-center 850:flex md:hidden xs:flex 850:justify-center max-md:justify-center max-md:items-center"
              alt="Param Logo"
            />
          </Link>
          {/* <Link to="/" className="">
            <img
              src={microsoftpartner}
              className="xs:w-[120px] md:w-[120px] 1500:w-52 1200:w-[180px] lg:w-[150px] h-auto xs:items-center xs:flex xs:justify-center"
              alt="microsoft partner Logo"
            />
          </Link> */}
        </div>

        {/* -------------------------------------------  Navigation Links  -------------------------------------------  */}

        <div>
          <nav className="hidden md:flex">
            <ul className="text-white flex gap-4 1600:gap-8 1200:gap-[30px] lg:gap-[20px] font-semibold text-sm 1300:text-lg 1080:text-[16px]">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/aboutus" },
                { name: "Our Ventures", path: "/our-services" },
                { name: "Our Services", path: "/providedServices" },
                { name: "Technology", path: "/technology" },
                { name: "Our Clients", path: "/our-clients" },
                { name: "Career", path: "/careers" },
                { name: "Contact Us", path: "/contact-us" },
              ].map((link) => (
                <li key={link.path} className="group">
                  <Link
                    to={link.path}
                    className={`relative ${
                      isActive(link.path)
                        ? "text-gradient"
                        : "hover:text-gradient"
                    }`}
                  >
                    {link.name}
                    <div
                      className={`absolute left-0 bottom-0 h-[2px] ${
                        isActive(link.path) ? "w-full" : "w-0"
                      } bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] group-hover:w-full transition-all duration-500`}
                      style={{
                        width: isActive(link.path) ? "calc(100% - 10px)" : "0",
                      }}
                    ></div>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div
          className={`lg:hidden bg-black/45 fixed top-0 left-0 h-screen w-full  ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
          onClick={() => setIsOpen(false)}
        >
          <div className="bg-white  w-[70%]  text-black flex flex-col z-50 gap-6 transition-transform  duration-300">
            <button
              className=" flex justify-end text-3xl mt-5 mr-5"
              onClick={() => setIsOpen(false)}
            >
              <img src={closeButton} className="w-8 h-8" alt="close icon" />
            </button>
            <ul className="flex flex-col gap-6 text-lg font-semibold  w-full z-50 h-screen static ">
              {[
                { name: "Home", path: "/" },
                { name: "About Us", path: "/aboutus" },
                { name: "Our Ventures", path: "/our-services" },
                { name: "Our Services", path: "/providedServices" },
                { name: "Technology", path: "/technology" },
                { name: "Our Clients", path: "/our-clients" },
                { name: "Career", path: "/careers" },
                { name: "Contact Us", path: "/contact-us" },
              ].map((link) => (
                <li key={link.path} onClick={() => setIsOpen(false)}>
                  <Link
                    to={link.path}
                    className={`block px-4 py-2 ${
                      isActive(link.path)
                        ? "text-gradient"
                        : "hover:text-gradient"
                    }`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
